module.exports = "<div class=\"regular-saving-plan-wrapper\">\r\n  <div class=\"regular-savings-plan-content\">\r\n    <ng-container *ngFor=\"let question of data.questionaire | myFinancial :isShowSlider\">\r\n      <app-single-slider [form]=\"data.form\" [question]=\"question\"></app-single-slider>\r\n    </ng-container>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/features/my-financial/my-regular-saving-plan/my-regular-saving-plan.component.html
// module id = ./src/app/features/my-financial/my-regular-saving-plan/my-regular-saving-plan.component.html
// module chunks = main